export type FnaPresentationVariant = "legacy" | "zuu";

export function resolveFnaPresentationVariant(input: {
  fnaVersion?: string | null;
}): FnaPresentationVariant {
  if (input.fnaVersion?.startsWith("zuu.")) {
    return "zuu";
  }

  return "legacy";
}

export function isZuuFnaVariant(input: {
  fnaVersion?: string | null;
}): boolean {
  return resolveFnaPresentationVariant(input) === "zuu";
}

export function isZuuFinancialStepVariant(input: {
  fnaVersion?: string | null;
}): boolean {
  return isZuuFnaVariant(input);
}
